import { all, call, put, takeLatest } from 'typed-redux-saga/macro';
import { PROJECTS_URL } from '../../constants/api.constants';
import { apiRequestWrapper } from '../../utils/api/api.utils';
import { setIsError } from '../error/error.action';
import { setIsLoading } from '../loading/loading.action';
import { getMyProjectsFailed, getMyProjectsSuccess, getProjectFailed, GetProjectStart, getProjectSuccess } from './project.action';
import { PROJECT_ACTION_TYPES } from './project.type';

export function* getProject(
    { payload: { projectId, nodeId } }: GetProjectStart
) {
    yield* put(setIsLoading(true));
    try {
        const project = yield* call(
            apiRequestWrapper, `${PROJECTS_URL}${projectId}/`, 'GET', null
        );

        if (project) {
            yield* put(getProjectSuccess(project, nodeId));
        }
        yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getProjectFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* getMyProjects() {
    yield* put(setIsLoading(true));
    try {
        const myProjects = yield* call(
            apiRequestWrapper, `${PROJECTS_URL}me/`, 'GET', null
        );

        if (myProjects) {
            yield* put(getMyProjectsSuccess(myProjects));
        }
        yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getMyProjectsFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* onGetProjectStart() {
    yield* takeLatest(PROJECT_ACTION_TYPES.GET_PROJECT_START, getProject);
}

export function* onGetMyProjectsStart() {
    yield* takeLatest(PROJECT_ACTION_TYPES.GET_MY_PROJECTS_START, getMyProjects);
}

export function* projectSaga() {
    yield* all([
        call(onGetProjectStart),
        call(onGetMyProjectsStart)
    ]);
}